import * as ReselectModule from "reselect";
import { IClientFolderListState } from ".";
import { IApplicationState } from "..";

export const selectClientFolderList: ReselectModule.Selector<
  IApplicationState,
  IClientFolderListState
> = (state) => state.clientFolderList;
